// extracted by mini-css-extract-plugin
export default {"tableContainer":"TableContainer_tableContainer__cCaic","fadeInUp":"TableContainer_fadeInUp__fjTny"};